// extracted by mini-css-extract-plugin
module.exports = {"page":"TrainPage_page__3aywU page_page__31uF2"};